import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Styles from './TransactionsStatsCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { AnalyticsDataCard } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { formatNumber } from 'Utils/Calculations'
import { useTranslation } from 'react-i18next'
import AuthSelectors from 'Stores/Auth/Selectors'
import { getEnergyUnit } from 'Utils/Calculations'

const TransactionsStatsCard = ({
  transactionsStatistics,
  fetchTransactionsStatistics,
  fetchTransactionsStatisticsRequestState,
  operator,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchTransactionsStatistics()
  }, [])

  const chargedValue = transactionsStatistics?.data?.whCharged || 0

  const { divisor, unit } = getEnergyUnit(chargedValue)
  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.Top}>
        <AnalyticsDataCard
          title={t('Analytics.Revenue')}
          subtitle={t('Analytics.SinceThisMonth')}
          percentage={transactionsStatistics?.data?.transactionRevenueChange}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.transactionRevenue,
          )}
          unit={operator.country.currency.code}
          body={` ${
            fetchTransactionsStatisticsRequestState === RequestState.LOADING ||
            fetchTransactionsStatisticsRequestState ===
              RequestState.SUCCEEDED ||
            fetchTransactionsStatisticsRequestState ==
              RequestState.UNINITIALIZED
              ? formatNumber(transactionsStatistics?.data?.averagePerCharge)
              : '-'
          } ${t('Analytics.AverageRevenue')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />

        <AnalyticsDataCard
          title={t('Analytics.Co2')}
          subtitle={t('Analytics.SinceThisMonth')}
          percentage={transactionsStatistics?.data?.co2SavedChange}
          primaryValue={formatNumber(transactionsStatistics?.data?.co2Saved)}
          unit={t('Analytics.Kg')}
          body={` ${
            fetchTransactionsStatisticsRequestState === RequestState.LOADING ||
            fetchTransactionsStatisticsRequestState ===
              RequestState.SUCCEEDED ||
            fetchTransactionsStatisticsRequestState ==
              RequestState.UNINITIALIZED
              ? formatNumber(transactionsStatistics?.data?.co2Emitted)
              : '-'
          } ${t('Analytics.Emitted')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.CarbonFootprint')}
          primaryValue={formatNumber(transactionsStatistics?.data?.co2Saved)}
          unit={t('Analytics.Kg')}
          secondaryValue={formatNumber(transactionsStatistics?.data?.fuelSaved)}
          primaryLabel={t('Analytics.Co2Saved')}
          secondaryLabel={t('Analytics.FuelSaved')}
          body={` ${
            fetchTransactionsStatisticsRequestState === RequestState.LOADING ||
            fetchTransactionsStatisticsRequestState ===
              RequestState.SUCCEEDED ||
            fetchTransactionsStatisticsRequestState ==
              RequestState.UNINITIALIZED
              ? chargedValue > 0
                ? (chargedValue / divisor).toFixed(1)
                : chargedValue
              : '-'
          } ${unit} ${t('Analytics.FootprintBody')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
      </div>
      <div className={Styles.Bottom}>
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Connectors')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.connectorsUsed,
          )}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Charged')}
          primaryValue={
            chargedValue > 0
              ? (chargedValue / divisor).toFixed(1)
              : chargedValue
          }
          unit={unit}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Time')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.timeChargedHours,
          )}
          unit={t('Analytics.Hours')}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.TransactionsCard')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.transactions,
          )}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  transactionsStatistics: AnalyticsSelectors.getTransactionsStatistics(state),
  fetchTransactionsStatisticsRequestState:
    AnalyticsSelectors.getFetchTransactionsStatisticsRequestState(state),
  operator: AuthSelectors.getOperator(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchTransactionsStatistics: () =>
      dispatch(AnalyticsActions.fetchTransactionsStatistics()),
  }
}
TransactionsStatsCard.propTypes = {
  transactionsStatistics: PropTypes.object,
  fetchTransactionsStatistics: PropTypes.func,
  fetchTransactionsStatisticsRequestState: PropTypes.number,
  operator: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransactionsStatsCard)
